import React, { Component } from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import { withRouter } from 'react-router-dom'

import Loader from 'src/components/Loader/Loader'
import { Layout, Container, PageTitle, Content } from 'src/components/Layout'
import {
  CardColumns,
  CardColumn,
  CardContactDetails,
  CardContactSummary,
} from 'src/components/Card'
import { isEmpty, hasFeatureFlag, capitalize } from 'src/utils/helpers'
import withToast from 'src/components/Toast'
import { Box, Flex, Text } from '@chakra-ui/react'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from './translations'
import styles from './Contact.module.less'

class Contact extends Component {
  componentDidMount() {
    const { featureFlags, history, getContactDetails } = this.props

    if (!hasFeatureFlag(featureFlags, 'pages.contact')) {
      history.push('/')
      return true
    }

    getContactDetails()
  }

  componentDidUpdate(prevProps) {
    const { intl, getContactDetailsResponse, toast } = this.props

    // If there is a response and it changed (it's empty object while submitting)
    if (
      !isEmpty(getContactDetailsResponse) &&
      getContactDetailsResponse !== prevProps.getContactDetailsResponse
    ) {
      // If there was error getting record
      if (getContactDetailsResponse.success !== true) {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            getContactDetailsResponse.message ||
            intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
  }

  render() {
    const {
      intl,
      isGetContactDetailsInProgress,
      companyData,
      otherBranches,
      csr,
      workingHours,
      countryIsoCode,
      timeZone,
    } = this.props

    const title =
      countryIsoCode && countryIsoCode.toLowerCase() === 'us'
        ? intl.formatMessage(intlMessages.contactHeaderMyAgent)
        : intl.formatMessage(intlMessages.contactHeaderMyBroker)

    return (
      <Layout>
        <Content>
          <PageTitle
            subtitle={<FormattedMessage id='app.profileTab' defaultMessage='Profile' />}
            title={capitalize(title)}
          />

          <Container className={styles.container}>
            {isGetContactDetailsInProgress ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <Flex direction={'column'}>
                <Flex mb={'15px'} direction={'row'} justify={'space-between'} align={'center'}>
                  <Text variant='secondary' fontSize={'20px'} fontWeight={'bold'}>
                    {intl.formatMessage(intlMessages.contactHeaderMyAgent)}
                  </Text>
                </Flex>
                <CardColumns isDual>
                  {!isEmpty(companyData) && (
                    <CardColumn>
                      <CardContactDetails
                        data={{
                          ...companyData,
                          workingHours,
                        }}
                        timeZone={timeZone}
                      />
                    </CardColumn>
                  )}

                  {!isEmpty(csr) && (
                    <CardColumn>
                      <CardContactSummary data={csr} companyData={companyData} />
                    </CardColumn>
                  )}
                </CardColumns>

                <Box mb={'15px'}>
                  <Text variant='secondary' fontSize={'20px'} fontWeight={'bold'}>
                    {intl.formatMessage(intlMessages.contactHeaderOtherBranches)}
                  </Text>
                </Box>

                <CardColumns>
                  {isEmpty(companyData) && isEmpty(csr) && isEmpty(otherBranches) ? (
                    <CardColumn className={styles.cardColumnTitle}>
                      <h3 className={styles.noResults}>
                        {intl.formatMessage(intlMessagesApp.appGlobalNoResults)}
                      </h3>
                    </CardColumn>
                  ) : (
                    ''
                  )}

                  {!isEmpty(otherBranches) && Array.isArray(otherBranches) && (
                    <React.Fragment>
                      {otherBranches.map((branch, branchKey) => {
                        return (
                          <CardColumn
                            key={'branch-' + branchKey}
                            className={styles.cardColumnOtherBranch}
                          >
                            <CardContactDetails
                              data={{
                                ...branch,
                                workingHours,
                              }}
                              timeZone={timeZone}
                              isCollapsible={true}
                            />
                          </CardColumn>
                        )
                      })}
                    </React.Fragment>
                  )}
                </CardColumns>
              </Flex>
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(Contact)))
